import { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import { radius, size, fontSize } from '../../../../../common/css/setting/variable';

interface IProps {
  title: string;
  description?: string;
  linkUrl?: string;
  imageUrl?: string;
  customLoggerParam: string;
}

const InnerStyle = css`
  display: flex;
  align-items: center;
  padding: 8px;
  border: 2px solid ${props => props.theme.news.palette.bor_notice_pc};
  border-radius: ${radius.middle_common};
`;

const Wrapper = styled.div`
  background-color: ${props => props.theme.news.palette.bg_lv1_common};
  border-radius: ${radius.middle_common};

  /* お知らせが続く場合余白をつける */
  & + & {
    margin-top: 8px;
  }
`;

const Icon = styled.span<{ $imageUrl: IProps['imageUrl'] }>`
  display: block;
  flex-shrink: 0;
  width: ${size.thumbnail_notice_common};
  height: ${size.thumbnail_notice_common};
  margin-right: 8px;
  background-image: url(${({ $imageUrl }) => $imageUrl});
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
`;

const Title = styled.p`
  font-size: ${fontSize.px12};
  line-height: 1.3;
`;

const NoLink = styled.div`
  ${InnerStyle}
`;

const Link = styled.a`
  ${InnerStyle}

  &:visited ${Title} {
    color: ${props => props.theme.news.palette.link_visited_pc};
  }

  &:hover {
    text-decoration: none;
    background-color: ${props => props.theme.news.palette.bg_hover_normal_pc};

    ${Title} {
      color: ${props => props.theme.news.palette.link_hover_pc};
      text-decoration: underline;
    }
  }
`;

const Text = styled.div``;

const Description = styled.p`
  margin-top: 4px;
  font-size: ${fontSize.px12};
  line-height: 1.3;
  color: ${props => props.theme.news.palette.text_sub_lv1_common};
`;

export default class NoticeItemMainColumn extends Component<IProps> {
  /**
   *
   */
  public render() {
    const noticeBody = (
      <Fragment>
        {this.props.imageUrl ? <Icon $imageUrl={this.props.imageUrl} /> : null}
        <Text>
          <Title>{this.props.title}</Title>
          {this.props.description ? <Description>{this.props.description}</Description> : ''}
        </Text>
      </Fragment>
    );
    const noticeWrapper = !this.props.linkUrl ? (
      <NoLink>{noticeBody}</NoLink>
    ) : (
      <Link href={this.props.linkUrl} data-cl-params={this.props.customLoggerParam}>
        {noticeBody}
      </Link>
    );
    return <Wrapper>{noticeWrapper}</Wrapper>;
  }
}
